import FileUploader from "../../../../../util/component/FileUploader";
import * as React from "react";
import { Box } from "@mui/material";
import { useSetRecoilState } from "recoil";
import { STATE_REPORT_UPLOADING } from "../constants/EnelxRecoil";

const DropFileTemplate = () => {

    const setReportUploading = useSetRecoilState(STATE_REPORT_UPLOADING);

    return (
            <Box sx={{ minWidth: '50vw', pointerEvents: 'auto !important' }}>
                <FileUploader onUpload={(file: File) => setReportUploading(file)}
                              onRemove={() => setReportUploading(undefined)}
                              acceptedFiles={{
                                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [".xlsx"],
                              }}/>
            </Box>
    );
}

export default DropFileTemplate;